/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 11:03:46
 * @version 1.0.0
 */

import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { IRootState } from '@src/types';
import { SFCAvatar } from '@src/features/common';
import DefaultAvatar from '@src/assets/default_avatar.png';
import {
  ADMIN_MAP,
  ADMIN_MALL_LIST,
  ADMIN_BANNER_LIST,
  BANNER_MAP,
  BANNER_TAB_ARTICLE,
  BANNER_TAB_ASK,
  MALL_MAP,
  ADMIN_ORDER_LIST
} from '@src/utils/constant/adminUsers';

import { Menu, Dropdown } from 'antd';

import './AdminHeader.less';

type StateProps = ReturnType<typeof mapStateToProps>;

export interface IAdminHeaderProps {
  pathname?: string;
}
type Props = StateProps & IAdminHeaderProps;

export const AdminHeader: React.SFC<Props> = (props: Props) => {
  const { userInfo = {}, pathname = '' } = props;
  const tabKey = pathname.split('/')[2];

  const menu = (
    <Menu>
      {MALL_MAP.data.map(item => {
        return (
          <Menu.Item key={item.key}>
            <NavLink activeClassName="active-item" to={`/admin/${item.key}`} className="item">
              {item.name}
            </NavLink>
          </Menu.Item>
        );
      })}
    </Menu>
  );
  const banner = (
    <Menu>
      {BANNER_MAP.data.map(item => {
        return (
          <Menu.Item key={item.key}>
            <NavLink
              activeClassName="active-item"
              to={`/admin/bannerList/${item.key}`}
              className="item"
            >
              {item.name}
            </NavLink>
          </Menu.Item>
        );
      })}
    </Menu>
  );
  const avaterMenu = (
    <Menu>
      <Menu.Item>
        <NavLink
          activeClassName="active-item"
          to={`/personal/${userInfo.username}`}
          className="item"
        >
          个人页面
        </NavLink>
      </Menu.Item>
      <Menu.Item>
        <NavLink activeClassName="active-item" to="/admin/artList" className="item">
          后台管理
        </NavLink>
      </Menu.Item>
    </Menu>
  );
  return (
    <div className="k-tech-admin-header">
      <div className="left">
        <Link to="/" className="logo__link" />
        {ADMIN_MAP.data.map(item => {
          if (item.index === ADMIN_MALL_LIST) {
            return (
              <Dropdown overlay={menu} key={item.index}>
                <span
                  className={
                    tabKey === ADMIN_MALL_LIST || tabKey === ADMIN_ORDER_LIST
                      ? 'item active-item'
                      : 'item'
                  }
                >
                  {item.title}
                </span>
              </Dropdown>
            );
          } else if (item.index === ADMIN_BANNER_LIST) {
            return (
              <Dropdown overlay={banner} key={item.index}>
                <span
                  className={
                    tabKey === BANNER_TAB_ARTICLE || tabKey === BANNER_TAB_ASK
                      ? 'item active-item'
                      : 'item'
                  }
                >
                  {item.title}
                </span>
              </Dropdown>
            );
          }
          return (
            <NavLink
              to={`/admin/${item.index}`}
              className={tabKey === item.index ? 'item active-item' : 'item'}
              key={item.index}
            >
              {item.title}
            </NavLink>
          );
        })}
      </div>
      {userInfo ? (
        userInfo.manageBackgroundAdmin ? (
          <Dropdown overlay={avaterMenu}>
            <img className="header__avatar" src={userInfo.photo || DefaultAvatar} />
          </Dropdown>
        ) : (
          <Link to={`/personal/${userInfo.username}`} className="link">
            <SFCAvatar className="header__avatar" src={userInfo.photo} />
          </Link>
        )
      ) : (
        <SFCAvatar className="header__avatar" />
      )}
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state: IRootState) {
  return {
    userInfo: state.common.userInfo
  };
}

export default connect<StateProps>(mapStateToProps)(React.memo(AdminHeader));
